import { breakpoints } from '../../../../resources/scripts/vendor/tailwind';

document.addEventListener('alpine:init', () => {
  window.Alpine.data('accordionSlider', () => ({
    activeIndex: 0,
    isAccordionActive: false,

    init () {
      new window.Splide(this.$el, {
        'type': 'fade',
        'arrows': false,
        breakpoints: {
          [breakpoints.md]: {
            destroy: true
          },
        },
      })
        .on('pagination:mounted', function (data) {
          const labels = eval(data.list.dataset.labels);
          data.list.classList.add('splide__pagination--accordion');

          data.items.forEach(function (item) {
            item.button.classList.add('pagination-item');
            item.button.textContent = labels[item.page];
          });
        })
        .mount();

      if(window.innerWidth < breakpoints.md) {
        this.isAccordionActive = true;
      }
    }
  }));
});
